<ng-template #contentHeaderTemplate>
  <div class="row">
    <div class="col-12 d-flex justify-content-end ">
      <button class="btn btn-primary" (click)="save()">
        {{ (diagnosis?.id ? 'misc.save_btn' : 'misc.create_btn') | translate }}
      </button>
    </div>
  </div>
</ng-template>

<div class="row g-3">

  <div class="col-12 col-md-9 order-md-1">
    <form [formGroup]="form" (submit)="save()">
      <div class="card mb-3">
        <div class="card-header">
          {{ 'authenticated.administration.diagnoses.edit.header' | translate }}
        </div>
        <div class="card-body">

          <div class="row">

            <div class="col-12 col-lg-6 py-1">
              <app-form-group
                [formControl]="form.controls.title.controls.de"
                label="{{'authenticated.administration.diagnoses.edit.form.title_de.label' | translate }}"
                [errorMessages]="{required: ('authenticated.administration.diagnoses.edit.form.title_de.validation_messages.required' | translate)}"
              ></app-form-group>
            </div>

            <div class="col-12 col-lg-6 py-1">
              <app-form-group
                [formControl]="form.controls.title.controls.en"
                label="{{'authenticated.administration.diagnoses.edit.form.title_en.label' | translate }}"
                [errorMessages]="{required: ('authenticated.administration.diagnoses.edit.form.title_en.validation_messages.required' | translate)}"
              ></app-form-group>
            </div>

            <div class="col-12 col-lg-6 py-1">
              <app-form-group
                [formControl]="form.controls.title.controls.ru"
                label="{{'authenticated.administration.diagnoses.edit.form.title_ru.label' | translate }}"
                [errorMessages]="{required: ('authenticated.administration.diagnoses.edit.form.title_ru.validation_messages.required' | translate)}"
              ></app-form-group>
            </div>

            <div class="col-12 col-lg-6 py-1">
              <app-multi-select-with-service-list
                [service]="diagnosisService"
                [filters]="{'is_category': true}"
                [searchOnField]="'title'"
                [formControl]="form.controls.parent_id"
                label="{{'authenticated.administration.diagnoses.edit.form.parent_id.label' | translate }}"
                [sort]="'-created_at'"
                [selectionMode]="'single_id'"
              ></app-multi-select-with-service-list>
            </div>

            <div class="col-12 col-lg-6 py-1">
              <app-form-group
                [formControl]="form.controls.contact_form_slug"
                label="{{'authenticated.administration.diagnoses.edit.form.contact_form_slug.label' | translate }}"
                tooltipText="{{'authenticated.administration.diagnoses.edit.form.contact_form_slug.tooltip' | translate }}"
                [errorMessages]="{
                  pattern: ('authenticated.administration.diagnoses.edit.form.contact_form_slug.validation_messages.pattern' | translate),
                  maxlength: ('authenticated.administration.diagnoses.edit.form.contact_form_slug.validation_messages.maxlength' | translate)
                }"
              ></app-form-group>
            </div>

            <div class="col-12 col-lg-6 py-1">
              <app-form-group
                [formControl]="form.controls.automatic_acceptance"
                [centerCheckbox]="true"
                type="checkbox"
                label="{{'authenticated.administration.diagnoses.edit.form.automatic_acceptance.label' | translate }}"
              ></app-form-group>
            </div>

            <div class="col-12 col-lg-6 py-1">
              @if (form.controls.automatic_acceptance.value) {
                <app-multi-select-with-service-list
                  [service]="emailService"
                  [searchOnField]="'title'"
                  [filters]="{type: EmailTypeEnum.PATIENT_ACCEPTANCE}"
                  [formControl]="form.controls.automatic_acceptance_email_id"
                  label="{{'authenticated.administration.diagnoses.edit.form.automatic_acceptance_email_id.label' | translate }}"
                  [errorMessages]="{required: ('authenticated.administration.diagnoses.edit.form.automatic_acceptance_email_id.validation_messages.required' | translate)}"
                  [sort]="'-created_at'"
                  [selectionMode]="'single_id'"
                ></app-multi-select-with-service-list>
              }
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>


  <div class="col-12 col-md-3 order-md-2">
    <form [formGroup]="form" (submit)="save()">
      <app-state-card
        formControlName="state"
      ></app-state-card>
    </form>

    @if (diagnosis) {
      <app-delete-card
        [disabled]="diagnosis.state !== ModelStateEnum.DRAFT"
        *appIfHasAllPermissions="[PERMISSION.ADMINISTRATION_DIAGNOSIS_DELETE_ALL]"
        itemName="{{ 'authenticated.administration.diagnoses.delete.item' | translate }}"
        (deleteTriggered)="delete()"
      ></app-delete-card>
    }
  </div>
</div>
